var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBigPriceTagTip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.399,
    height: 32.497,
    viewBox: "0 0 15.399 32.497",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Price_Tag_Tip_-_big",
    "data-name": "Price Tag Tip - big",
    transform: "translate(-135.743 -320.753)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_163313",
    "data-name": "Path 163313",
    d: "M137.323,340.334,149.381,353h1.595V321h-1.595l-12.058,12.663A4.977,4.977,0,0,0,137.323,340.334Zm6.764-6.67a3.627,3.627,0,0,1,3.5,3.335,3.954,3.954,0,0,1-3.5,3.673A3.893,3.893,0,0,1,140.652,337,3.565,3.565,0,0,1,144.087,333.663Z",
    transform: "translate(0.024 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163314",
    "data-name": "Path 163314",
    d: "M150.892,321h-1.5l-12.052,12.663a4.861,4.861,0,0,0,0,6.67c3,3.657,12.052,12.663,12.052,12.663h1.5",
    transform: "translate(0 0.001)",
    fill: "none",
    stroke: "#b1b3b3",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163315",
    "data-name": "Path 163315",
    d: "M3.625,0A3.625,3.625,0,1,1,0,3.625,3.625,3.625,0,0,1,3.625,0Z",
    transform: "translate(140.5 333.5)",
    fill: "none",
    stroke: "#b1b3b3",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigPriceTagTip);
export default __webpack_public_path__ + "static/media/big-price-tag-tip.6a3d52981918cba057b2cb82d6b68ef8.svg";
export { ForwardRef as ReactComponent };